module.exports = __webpack_public_path__ + "img/ic-popup-close-white.4fbcd3fe.svg";